import CalendarAgendaEventDirective from "./CalendarAgendaEvent";
import CalendarDayEventComponent from "./CalendarDayEvent";
import CalendarThreeDayEventComponent from "./CalendarThreeDayEvent";
import CalendarWeekEventComponent from "./CalendarWeekEvent";
import CalendarMonthEventComponent from "./CalendarMonthEvent";

import DependencyListBuilder from "../../../utility/DependencyListBuilder";

const calendarEventModuleDependencies = DependencyListBuilder([
    CalendarAgendaEventDirective.dependencies,
    CalendarDayEventComponent.dependencies,
    CalendarThreeDayEventComponent.dependencies,
    CalendarWeekEventComponent.dependencies,
    CalendarMonthEventComponent.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view.calendar-event",
        calendarEventModuleDependencies
    )
    .component(CalendarDayEventComponent.name, CalendarDayEventComponent.config)
    .component(CalendarThreeDayEventComponent.name, CalendarThreeDayEventComponent.config)
    .component(CalendarWeekEventComponent.name, CalendarWeekEventComponent.config)
    .component(CalendarMonthEventComponent.name, CalendarMonthEventComponent.config)
    .directive(CalendarAgendaEventDirective.name, CalendarAgendaEventDirective.definition)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/index.js
// module id = c5/o
// module chunks = 1